/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Comment */
export interface Comment {
  /** Comment */
  comment: string;
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /** Resource Id */
  resource_id: string;
}

/** CommentList */
export interface CommentList {
  /** Comments */
  comments: Comment[];
}

/** Entry */
export interface Entry {
  /** Entry */
  entry: string;
  /** Count */
  count: number;
}

/** EntryList */
export interface EntryList {
  /** Entries */
  entries: Entry[];
}

/** GetPacketPdfParams */
export interface GetPacketPdfParams {
  /**
   * Two Page Align
   * @default false
   */
  two_page_align?: boolean;
}

/** IndexResponse */
export interface IndexResponse {
  /** Status */
  status: "ok" | "down";
  /** Version */
  version: string;
  /** Deployedat */
  deployedAt: string;
}

/** ListSongParams */
export interface ListSongParams {
  /**
   * Ccli Num
   * @default null
   */
  ccli_num?: number | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
}

/** LoginResponse */
export interface LoginResponse {
  /** Token */
  token: string;
}

/** NewComment */
export interface NewComment {
  /** Comment */
  comment: string;
}

/** NewSetlist */
export interface NewSetlist {
  /** Leader Name */
  leader_name: string;
  /**
   * Service Date
   * @default null
   */
  service_date?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Participants
   * @default []
   */
  participants?: string[];
}

/** NewSetlistPosition */
export interface NewSetlistPosition {
  /** Index */
  index: number;
  /** Label */
  label: string;
  /** Is Music */
  is_music: boolean;
  /**
   * Presenter
   * @default null
   */
  presenter?: string | null;
  /**
   * Status
   * @default null
   */
  status?: "open" | "in-progress" | "final" | null;
}

/** NewSetlistRecording */
export interface NewSetlistRecording {
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Object Id */
  object_id: string;
  /** Object Type */
  object_type: string;
  /** Duration */
  duration: number;
  /**
   * Waveform
   * @default null
   */
  waveform?: string | null;
}

/** NewSetlistRecordingMark */
export interface NewSetlistRecordingMark {
  /** Offset Sec */
  offset_sec: number;
  /** Setlist Position Id */
  setlist_position_id: string | null;
  /** Song Version Id */
  song_version_id: string | null;
  /** Cue Title */
  cue_title: string | null;
}

/** NewSetlistSheet */
export interface NewSetlistSheet {
  /** Type */
  type:
    | "1:primary"
    | "2:secondary"
    | "3:extra"
    | "4:candidate-high"
    | "5:candidate"
    | "6:candidate-low";
  /** Song Sheet Id */
  song_sheet_id: string;
  /**
   * Setlist Position Id
   * @default null
   */
  setlist_position_id?: string | null;
}

/** NewSetlistTemplate */
export interface NewSetlistTemplate {
  /** Title */
  title: string;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
}

/** NewSetlistTemplatePosition */
export interface NewSetlistTemplatePosition {
  /** Index */
  index: number;
  /** Label */
  label: string;
  /** Is Music */
  is_music: boolean;
  /**
   * Presenter
   * @default null
   */
  presenter?: string | null;
}

/** NewSong */
export interface NewSong {
  /** Title */
  title: string;
  /** Authors */
  authors: string[];
  /** CCLI Number */
  ccli_num: number | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
}

/** NewSongMedia */
export interface NewSongMedia {
  /** Title */
  title: string;
  /**
   * Url
   * @default null
   */
  url?: string | null;
  /**
   * Object Id
   * @default null
   */
  object_id?: string | null;
  /**
   * Media Type
   * @default null
   */
  media_type?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
}

/** NewSongSheet */
export interface NewSongSheet {
  /** Type */
  type: string;
  /** Key */
  key: string;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Object Id */
  object_id: string;
  /** Object Type */
  object_type: string;
  /**
   * Auto Verse Order
   * @default true
   */
  auto_verse_order?: boolean;
}

/** NewSongVersion */
export interface NewSongVersion {
  /** Label */
  label: string;
  /**
   * Verse Order
   * @default null
   */
  verse_order?: string | null;
  /**
   * Lyrics
   * @default null
   */
  lyrics?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
}

/** ObjectId */
export interface ObjectId {
  /** Id */
  id: string;
}

/** PositionLyricDetails */
export interface PositionLyricDetails {
  /** Position Id */
  position_id: string;
  /** Title */
  title: string;
  /** Lyrics */
  lyrics: string | null;
  /**
   * Verse Order
   * @default null
   */
  verse_order?: string | null;
}

/** Song */
export interface Song {
  /** Title */
  title: string;
  /** Authors */
  authors: string[];
  /** CCLI Number */
  ccli_num: number | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /**
   * Last Modified
   * @format date-time
   */
  last_modified: string;
}

/** SearchSongHit */
export interface SearchSongHit {
  song: Song;
  /** Highlighted */
  highlighted: string;
  /** Rank */
  rank: number;
}

/** SearchSongList */
export interface SearchSongList {
  /** Hits */
  hits: SearchSongHit[];
}

/** SearchSongParams */
export interface SearchSongParams {
  /** Search query */
  q: string;
}

/** ServerError */
export interface ServerError {
  /** Code */
  Code: string;
  /** Message */
  Message: string;
}

/** Setlist */
export interface Setlist {
  /** Leader Name */
  leader_name: string;
  /**
   * Service Date
   * @default null
   */
  service_date?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Participants
   * @default []
   */
  participants?: string[];
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /**
   * Music Packet Object Id
   * @default null
   */
  music_packet_object_id?: string | null;
}

/** SetlistInfo */
export interface SetlistInfo {
  /** Service Date */
  service_date: string | null;
  /** Title */
  title: string | null;
  /** Lyrics */
  lyrics: PositionLyricDetails[];
}

/** SetlistList */
export interface SetlistList {
  /** Setlists */
  setlists: Setlist[];
}

/** SetlistPosition */
export interface SetlistPosition {
  /** Index */
  index: number;
  /** Label */
  label: string;
  /** Is Music */
  is_music: boolean;
  /**
   * Presenter
   * @default null
   */
  presenter?: string | null;
  /**
   * Status
   * @default null
   */
  status?: "open" | "in-progress" | "final" | null;
  /** Id */
  id: string;
  /** Setlist Id */
  setlist_id: string;
}

/** SetlistPositionList */
export interface SetlistPositionList {
  /** Positions */
  positions: SetlistPosition[];
}

/** SetlistRecording */
export interface SetlistRecording {
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Object Id */
  object_id: string;
  /** Object Type */
  object_type: string;
  /** Duration */
  duration: number;
  /**
   * Waveform
   * @default null
   */
  waveform?: string | null;
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /** Setlist Id */
  setlist_id: string;
}

/** SetlistRecordingList */
export interface SetlistRecordingList {
  /** Recordings */
  recordings: SetlistRecording[];
}

/** SetlistRecordingMark */
export interface SetlistRecordingMark {
  /** Offset Sec */
  offset_sec: number;
  /** Setlist Position Id */
  setlist_position_id: string | null;
  /** Song Version Id */
  song_version_id: string | null;
  /** Cue Title */
  cue_title: string | null;
  /** Id */
  id: string;
  /** Recording Id */
  recording_id: string;
  /** Song Id */
  song_id: string | null;
  /** Setlist Id */
  setlist_id: string | null;
}

/** SetlistRecordingMarkList */
export interface SetlistRecordingMarkList {
  /** Marks */
  marks: SetlistRecordingMark[];
}

/** SetlistSheet */
export interface SetlistSheet {
  /** Type */
  type:
    | "1:primary"
    | "2:secondary"
    | "3:extra"
    | "4:candidate-high"
    | "5:candidate"
    | "6:candidate-low";
  /** Song Sheet Id */
  song_sheet_id: string;
  /**
   * Setlist Position Id
   * @default null
   */
  setlist_position_id?: string | null;
  /** Id */
  id: string;
  /** Setlist Id */
  setlist_id: string;
  /** Song Version Id */
  song_version_id: string;
  /** Song Id */
  song_id: string;
}

/** SetlistSheetList */
export interface SetlistSheetList {
  /** Sheets */
  sheets: SetlistSheet[];
}

/** SetlistTemplate */
export interface SetlistTemplate {
  /** Title */
  title: string;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
}

/** SetlistTemplateList */
export interface SetlistTemplateList {
  /** Templates */
  templates: SetlistTemplate[];
}

/** SetlistTemplatePosition */
export interface SetlistTemplatePosition {
  /** Index */
  index: number;
  /** Label */
  label: string;
  /** Is Music */
  is_music: boolean;
  /**
   * Presenter
   * @default null
   */
  presenter?: string | null;
  /** Id */
  id: string;
  /** Template Id */
  template_id: string;
}

/** SetlistTemplatePositionList */
export interface SetlistTemplatePositionList {
  /** Positions */
  positions: SetlistTemplatePosition[];
}

/** SongHistory */
export interface SongHistory {
  /** Recent Played */
  recent_played: string | null;
  /** Recent Played Setlist Id */
  recent_played_setlist_id: string | null;
  /** First Played */
  first_played: string | null;
  /** First Played Setlist Id */
  first_played_setlist_id: string | null;
  /** Num Played */
  num_played: number;
  /** Num Played Past Year */
  num_played_past_year: number;
}

/** SongHistorySetlist */
export interface SongHistorySetlist {
  /** Id */
  id: string;
  /** Leader Name */
  leader_name: string;
  /** Service Date */
  service_date: string | null;
  /** Sheet Ids */
  sheet_ids: string[];
}

/** SongHistorySetlists */
export interface SongHistorySetlists {
  /** Setlists */
  setlists: SongHistorySetlist[];
}

/** SongList */
export interface SongList {
  /** Songs */
  songs: Song[];
}

/** SongMedia */
export interface SongMedia {
  /** Title */
  title: string;
  /**
   * Url
   * @default null
   */
  url?: string | null;
  /**
   * Object Id
   * @default null
   */
  object_id?: string | null;
  /**
   * Media Type
   * @default null
   */
  media_type?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /** Song Version Id */
  song_version_id: string;
}

/** SongMediaList */
export interface SongMediaList {
  /** Song Media */
  song_media: SongMedia[];
}

/** SongRevisionSong */
export interface SongRevisionSong {
  /** Title */
  title: string;
  /** Authors */
  authors: string[];
  /** CCLI Number */
  ccli_num: number | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Rev Id */
  rev_id: string;
  /**
   * Rev Created On
   * @format date-time
   */
  rev_created_on: string;
  /** Rev Changed By */
  rev_changed_by: string | null;
  /** Id */
  id: string;
  /** Rev Type */
  rev_type: "song";
}

/** SongRevisionSongSheet */
export interface SongRevisionSongSheet {
  /** Type */
  type: string;
  /** Key */
  key: string;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Object Id */
  object_id: string;
  /** Object Type */
  object_type: string;
  /**
   * Auto Verse Order
   * @default true
   */
  auto_verse_order?: boolean;
  /** Rev Id */
  rev_id: string;
  /**
   * Rev Created On
   * @format date-time
   */
  rev_created_on: string;
  /** Rev Changed By */
  rev_changed_by: string | null;
  /** Id */
  id: string;
  /** Rev Type */
  rev_type: "song_sheet";
  /** Song Id */
  song_id: string;
  /** Song Version Id */
  song_version_id: string;
}

/** SongRevisionSongVersion */
export interface SongRevisionSongVersion {
  /** Label */
  label: string;
  /**
   * Verse Order
   * @default null
   */
  verse_order?: string | null;
  /**
   * Lyrics
   * @default null
   */
  lyrics?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Rev Id */
  rev_id: string;
  /**
   * Rev Created On
   * @format date-time
   */
  rev_created_on: string;
  /** Rev Changed By */
  rev_changed_by: string | null;
  /** Id */
  id: string;
  /** Rev Type */
  rev_type: "song_version";
  /** Song Id */
  song_id: string;
}

/** SongRevisionList */
export interface SongRevisionList {
  /** Song Revisions */
  song_revisions: (
    | ({
        rev_type: "song";
      } & SongRevisionSong)
    | ({
        rev_type: "song_sheet";
      } & SongRevisionSongSheet)
    | ({
        rev_type: "song_version";
      } & SongRevisionSongVersion)
  )[];
}

/** SongSheet */
export interface SongSheet {
  /** Type */
  type: string;
  /** Key */
  key: string;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Object Id */
  object_id: string;
  /** Object Type */
  object_type: string;
  /**
   * Auto Verse Order
   * @default true
   */
  auto_verse_order?: boolean;
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /** Song Version Id */
  song_version_id: string;
}

/** SongSheetList */
export interface SongSheetList {
  /** Song Sheets */
  song_sheets: SongSheet[];
}

/** SongVersion */
export interface SongVersion {
  /** Label */
  label: string;
  /**
   * Verse Order
   * @default null
   */
  verse_order?: string | null;
  /**
   * Lyrics
   * @default null
   */
  lyrics?: string | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /** Song Id */
  song_id: string;
}

/** SongVersionList */
export interface SongVersionList {
  /** Song Versions */
  song_versions: SongVersion[];
}

/** SparkLineHistoryPoint */
export interface SparkLineHistoryPoint {
  /**
   * Mo Yr
   * @format date
   */
  mo_yr: string;
  /** Count */
  count: number;
}

/** SparkLineHistory */
export interface SparkLineHistory {
  /** Songs */
  songs: Record<string, SparkLineHistoryPoint[]>;
}

/** TopSong */
export interface TopSong {
  /** Title */
  title: string;
  /** Authors */
  authors: string[];
  /** CCLI Number */
  ccli_num: number | null;
  /**
   * Tags
   * @default []
   */
  tags?: string[];
  /** Id */
  id: string;
  /**
   * Created On
   * @format date-time
   */
  created_on: string;
  /** Creator Id */
  creator_id: string;
  /**
   * Last Modified
   * @format date-time
   */
  last_modified: string;
  /** Appearances */
  appearances: number;
}

/** TopSongParams */
export interface TopSongParams {
  /**
   * Ranking
   * @default "alltime"
   */
  ranking?: "alltime" | "recent" | "weighted";
  /**
   * Num
   * @default 50
   */
  num?: number;
}

/** TopSongs */
export interface TopSongs {
  /** Songs */
  songs: TopSong[];
}

/** UpdateComment */
export interface UpdateComment {
  /**
   * Comment
   * @default null
   */
  comment?: string | null;
}

/** UpdateSetlist */
export interface UpdateSetlist {
  /**
   * Leader Name
   * @default null
   */
  leader_name?: string | null;
  /**
   * Service Date
   * @default null
   */
  service_date?: string | null;
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Participants
   * @default null
   */
  participants?: string[] | null;
}

/** UpdateSetlistPosition */
export interface UpdateSetlistPosition {
  /**
   * Index
   * @default null
   */
  index?: number | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
  /**
   * Is Music
   * @default null
   */
  is_music?: boolean | null;
  /**
   * Presenter
   * @default null
   */
  presenter?: string | null;
  /**
   * Status
   * @default null
   */
  status?: "open" | "in-progress" | "final" | null;
}

/** UpdateSetlistPositions */
export interface UpdateSetlistPositions {
  /**
   * New Indexes
   * @default null
   */
  new_indexes?: Record<string, number> | null;
}

/** UpdateSetlistRecording */
export interface UpdateSetlistRecording {
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
  /**
   * Object Id
   * @default null
   */
  object_id?: string | null;
  /**
   * Object Type
   * @default null
   */
  object_type?: string | null;
  /**
   * Duration
   * @default null
   */
  duration?: number | null;
  /**
   * Waveform
   * @default null
   */
  waveform?: string | null;
}

/** UpdateSetlistRecordingMark */
export interface UpdateSetlistRecordingMark {
  /**
   * Offset Sec
   * @default null
   */
  offset_sec?: number | null;
  /**
   * Setlist Position Id
   * @default null
   */
  setlist_position_id?: string | null;
  /**
   * Song Version Id
   * @default null
   */
  song_version_id?: string | null;
  /**
   * Cue Title
   * @default null
   */
  cue_title?: string | null;
}

/** UpdateSetlistSheet */
export interface UpdateSetlistSheet {
  /**
   * Type
   * @default null
   */
  type?:
    | "1:primary"
    | "2:secondary"
    | "3:extra"
    | "4:candidate-high"
    | "5:candidate"
    | "6:candidate-low"
    | null;
  /**
   * Setlist Position Id
   * @default null
   */
  setlist_position_id?: string | null;
}

/** UpdateSetlistTemplate */
export interface UpdateSetlistTemplate {
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
}

/** UpdateSetlistTemplatePosition */
export interface UpdateSetlistTemplatePosition {
  /**
   * Index
   * @default null
   */
  index?: number | null;
  /**
   * Label
   * @default null
   */
  label?: string | null;
  /**
   * Is Music
   * @default null
   */
  is_music?: boolean | null;
  /**
   * Presenter
   * @default null
   */
  presenter?: string | null;
}

/** UpdateSong */
export interface UpdateSong {
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Authors
   * @default null
   */
  authors?: string[] | null;
  /**
   * CCLI Number
   * @default null
   */
  ccli_num?: number | null;
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
}

/** UpdateSongMedia */
export interface UpdateSongMedia {
  /**
   * Title
   * @default null
   */
  title?: string | null;
  /**
   * Url
   * @default null
   */
  url?: string | null;
  /**
   * Object Id
   * @default null
   */
  object_id?: string | null;
  /**
   * Media Type
   * @default null
   */
  media_type?: string | null;
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
}

/** UpdateSongSheet */
export interface UpdateSongSheet {
  /**
   * Type
   * @default null
   */
  type?: string | null;
  /**
   * Key
   * @default null
   */
  key?: string | null;
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
  /**
   * Object Id
   * @default null
   */
  object_id?: string | null;
  /**
   * Object Type
   * @default null
   */
  object_type?: string | null;
  /**
   * Auto Verse Order
   * @default null
   */
  auto_verse_order?: boolean | null;
}

/** UpdateSongVersion */
export interface UpdateSongVersion {
  /**
   * Label
   * @default null
   */
  label?: string | null;
  /**
   * Verse Order
   * @default null
   */
  verse_order?: string | null;
  /**
   * Lyrics
   * @default null
   */
  lyrics?: string | null;
  /**
   * Tags
   * @default null
   */
  tags?: string[] | null;
}

/** UpdateUser */
export interface UpdateUser {
  /**
   * Name
   * @default null
   */
  name?: string | null;
  /**
   * Email
   * @default null
   */
  email?: string | null;
  /**
   * Picture
   * @default null
   */
  picture?: string | null;
  /**
   * Role
   * @default null
   */
  role?:
    | "admin"
    | "manager"
    | "leader"
    | "viewer"
    | "pending"
    | "inactive"
    | null;
}

/** UploadDirect */
export interface UploadDirect {
  /** Url */
  url: string;
  /** Fields */
  fields: Record<string, string>;
}

/** UploadDirectFields */
export interface UploadDirectFields {
  /** Content Type */
  content_type: string;
}

/** UploadParams */
export interface UploadParams {
  /**
   * Base64
   * @default null
   */
  base64?: boolean | null;
}

/** User */
export interface User {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Provider Id */
  provider_id: string;
  /** Email */
  email: string;
  /**
   * Picture
   * @default null
   */
  picture?: string | null;
  /** Role */
  role: "admin" | "manager" | "leader" | "viewer" | "pending" | "inactive";
  /**
   * Api Key
   * @default null
   */
  api_key?: string | null;
}

/** UserApikey */
export interface UserApikey {
  /** Api Key */
  api_key: string;
}

/** UserList */
export interface UserList {
  /** Users */
  users: User[];
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/api";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title MusicTeam
 * @version 0.1.0
 * @baseUrl /api
 *
 * a music management tool
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Index
   * @name Index
   * @request GET:/
   * @secure
   */
  index = (params: RequestParams = {}) =>
    this.request<IndexResponse, ServerError>({
      path: `/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  auth = {
    /**
     * No description
     *
     * @tags Auth
     * @name AuthCallback
     * @request GET:/auth/callback
     * @secure
     */
    authCallback: (params: RequestParams = {}) =>
      this.request<any, ServerError>({
        path: `/auth/callback`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthGoogle
     * @request GET:/auth/google
     * @secure
     */
    authGoogle: (params: RequestParams = {}) =>
      this.request<any, ServerError>({
        path: `/auth/google`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLogin
     * @request POST:/auth/login
     * @secure
     */
    authLogin: (params: RequestParams = {}) =>
      this.request<LoginResponse, ServerError>({
        path: `/auth/login`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLogout
     * @request POST:/auth/logout
     * @secure
     */
    authLogout: (params: RequestParams = {}) =>
      this.request<any, ServerError>({
        path: `/auth/logout`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthSession
     * @request GET:/auth/session
     * @secure
     */
    authSession: (params: RequestParams = {}) =>
      this.request<User, ServerError>({
        path: `/auth/session`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  comments = {
    /**
     * No description
     *
     * @tags Comments
     * @name ListComments
     * @request GET:/comments/{resource_id}
     * @secure
     */
    listComments: (resourceId: string, params: RequestParams = {}) =>
      this.request<CommentList, ServerError>({
        path: `/comments/${resourceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comments
     * @name NewComment
     * @request POST:/comments/{resource_id}
     * @secure
     */
    newComment: (
      resourceId: string,
      data: NewComment,
      params: RequestParams = {},
    ) =>
      this.request<Comment, ServerError>({
        path: `/comments/${resourceId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comments
     * @name GetComment
     * @request GET:/comments/{resource_id}/{comment_id}
     * @secure
     */
    getComment: (
      resourceId: string,
      commentId: string,
      params: RequestParams = {},
    ) =>
      this.request<Comment, ServerError>({
        path: `/comments/${resourceId}/${commentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comments
     * @name UpdateComment
     * @request PUT:/comments/{resource_id}/{comment_id}
     * @secure
     */
    updateComment: (
      resourceId: string,
      commentId: string,
      data: UpdateComment,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/comments/${resourceId}/${commentId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Comments
     * @name DeleteComment
     * @request DELETE:/comments/{resource_id}/{comment_id}
     * @secure
     */
    deleteComment: (
      resourceId: string,
      commentId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/comments/${resourceId}/${commentId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  history = {
    /**
     * No description
     *
     * @tags History
     * @name GetSongHistory
     * @summary Get song history data
     * @request GET:/history/song/{song_id}
     * @secure
     */
    getSongHistory: (songId: string, params: RequestParams = {}) =>
      this.request<SongHistory, ServerError>({
        path: `/history/song/${songId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags History
     * @name GetSongHistorySetlists
     * @summary Get historical setlists that included this song
     * @request GET:/history/song/{song_id}/setlists
     * @secure
     */
    getSongHistorySetlists: (songId: string, params: RequestParams = {}) =>
      this.request<SongHistorySetlists, ServerError>({
        path: `/history/song/${songId}/setlists`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags History
     * @name GetHistorySparkline
     * @summary Get history data suitable for spark line render
     * @request GET:/history/sparkline
     * @secure
     */
    getHistorySparkline: (params: RequestParams = {}) =>
      this.request<SparkLineHistory, ServerError>({
        path: `/history/sparkline`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags History
     * @name GetHistoryTopSongs
     * @summary Get the top songs based on various methods
     * @request GET:/history/topSongs
     * @secure
     */
    getHistoryTopSongs: (
      query?: {
        /**
         * Ranking
         * @default "alltime"
         */
        ranking?: "alltime" | "recent" | "weighted";
        /**
         * Num
         * @default 50
         */
        num?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TopSongs, ServerError>({
        path: `/history/topSongs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  info = {
    /**
     * No description
     *
     * @tags Info
     * @name ListAuthors
     * @summary List all song authors
     * @request GET:/info/authors
     * @secure
     */
    listAuthors: (params: RequestParams = {}) =>
      this.request<EntryList, ServerError>({
        path: `/info/authors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Info
     * @name ListTags
     * @summary List all tags in the system, across songs, setlists, etc
     * @request GET:/info/tags
     * @secure
     */
    listTags: (params: RequestParams = {}) =>
      this.request<EntryList, ServerError>({
        path: `/info/tags`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Supported resource types: songs, song_versions, song_sheets, song_media, setlists, setlist_templates
     *
     * @tags Info
     * @name ListTagsByResourceType
     * @summary List all tags for a specific resource type
     * @request GET:/info/tags/{resource_type}
     * @secure
     */
    listTagsByResourceType: (
      resourceType: string,
      params: RequestParams = {},
    ) =>
      this.request<EntryList, ServerError>({
        path: `/info/tags/${resourceType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  objects = {
    /**
     * @description Limited to objects smaller than ~5 MB. If the `base64` field is True, then the request body will be decoded from Base64 before storage.
     *
     * @tags Objects
     * @name UploadFile
     * @summary Upload a file (object) to the site
     * @request POST:/objects
     * @secure
     */
    uploadFile: (
      data: string,
      query?: {
        /**
         * Base64
         * @default null
         */
        base64?: boolean | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ObjectId, ServerError>({
        path: `/objects`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Text,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Objects
     * @name UploadFileDirect
     * @summary Upload a file (object) directly to the site's underlying storage
     * @request POST:/objects/direct
     * @secure
     */
    uploadFileDirect: (data: UploadDirectFields, params: RequestParams = {}) =>
      this.request<UploadDirect, ServerError>({
        path: `/objects/direct`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Objects
     * @name UploadFileDirectPut
     * @summary Upload a file (object) directly to the site's storage via a PUT request
     * @request PUT:/objects/direct
     * @secure
     */
    uploadFileDirectPut: (
      data: UploadDirectFields,
      params: RequestParams = {},
    ) =>
      this.request<UploadDirect, ServerError>({
        path: `/objects/direct`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  ping = {
    /**
     * No description
     *
     * @tags Ping
     * @name Ping
     * @summary Wake the backend database
     * @request GET:/ping
     * @secure
     */
    ping: (params: RequestParams = {}) =>
      this.request<any, ServerError>({
        path: `/ping`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  setlistTemplates = {
    /**
     * No description
     *
     * @tags Setlists
     * @name ListSetlistTemplates
     * @request GET:/setlistTemplates
     * @secure
     */
    listSetlistTemplates: (params: RequestParams = {}) =>
      this.request<SetlistTemplateList, ServerError>({
        path: `/setlistTemplates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name NewSetlistTemplate
     * @request POST:/setlistTemplates
     * @secure
     */
    newSetlistTemplate: (
      data: NewSetlistTemplate,
      params: RequestParams = {},
    ) =>
      this.request<SetlistTemplate, ServerError>({
        path: `/setlistTemplates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistTemplate
     * @request GET:/setlistTemplates/{template_id}
     * @secure
     */
    getSetlistTemplate: (templateId: string, params: RequestParams = {}) =>
      this.request<SetlistTemplate, ServerError>({
        path: `/setlistTemplates/${templateId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlistTemplate
     * @request PUT:/setlistTemplates/{template_id}
     * @secure
     */
    updateSetlistTemplate: (
      templateId: string,
      data: UpdateSetlistTemplate,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlistTemplates/${templateId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name DeleteSetlistTemplate
     * @request DELETE:/setlistTemplates/{template_id}
     * @secure
     */
    deleteSetlistTemplate: (templateId: string, params: RequestParams = {}) =>
      this.request<any, ServerError>({
        path: `/setlistTemplates/${templateId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name ListSetlistTemplatePositions
     * @request GET:/setlistTemplates/{template_id}/pos
     * @secure
     */
    listSetlistTemplatePositions: (
      templateId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistTemplatePositionList, ServerError>({
        path: `/setlistTemplates/${templateId}/pos`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name NewSetlistTemplatePosition
     * @request POST:/setlistTemplates/{template_id}/pos
     * @secure
     */
    newSetlistTemplatePosition: (
      templateId: string,
      data: NewSetlistTemplatePosition,
      params: RequestParams = {},
    ) =>
      this.request<SetlistTemplatePosition, ServerError>({
        path: `/setlistTemplates/${templateId}/pos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistTemplatePosition
     * @request GET:/setlistTemplates/{template_id}/pos/{position_id}
     * @secure
     */
    getSetlistTemplatePosition: (
      templateId: string,
      positionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistTemplatePosition, ServerError>({
        path: `/setlistTemplates/${templateId}/pos/${positionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlistTemplatePosition
     * @request PUT:/setlistTemplates/{template_id}/pos/{position_id}
     * @secure
     */
    updateSetlistTemplatePosition: (
      templateId: string,
      positionId: string,
      data: UpdateSetlistTemplatePosition,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlistTemplates/${templateId}/pos/${positionId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name DeleteSetlistTemplatePosition
     * @request DELETE:/setlistTemplates/{template_id}/pos/{position_id}
     * @secure
     */
    deleteSetlistTemplatePosition: (
      templateId: string,
      positionId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlistTemplates/${templateId}/pos/${positionId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  setlists = {
    /**
     * No description
     *
     * @tags Setlists
     * @name ListSetlists
     * @request GET:/setlists
     * @secure
     */
    listSetlists: (params: RequestParams = {}) =>
      this.request<SetlistList, ServerError>({
        path: `/setlists`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name NewSetlist
     * @request POST:/setlists
     * @secure
     */
    newSetlist: (data: NewSetlist, params: RequestParams = {}) =>
      this.request<Setlist, ServerError>({
        path: `/setlists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlist
     * @request GET:/setlists/{setlist_id}
     * @secure
     */
    getSetlist: (setlistId: string, params: RequestParams = {}) =>
      this.request<Setlist, ServerError>({
        path: `/setlists/${setlistId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlist
     * @request PUT:/setlists/{setlist_id}
     * @secure
     */
    updateSetlist: (
      setlistId: string,
      data: UpdateSetlist,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name DeleteSetlist
     * @request DELETE:/setlists/{setlist_id}
     * @secure
     */
    deleteSetlist: (setlistId: string, params: RequestParams = {}) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Specifying "LATEST" as the setlist_id will retrieve info about the most recent setlist that has passed. Note that this endpoint is intentionally unauthenticated to offer this info to the general community.
     *
     * @tags Setlists
     * @name GetSetlistInfo
     * @summary Retrieve basic information, including lyrics, for this setlist
     * @request GET:/setlists/{setlist_id}/info
     * @secure
     */
    getSetlistInfo: (setlistId: string, params: RequestParams = {}) =>
      this.request<SetlistInfo, ServerError>({
        path: `/setlists/${setlistId}/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistPacketLyrics
     * @summary Retrieve the text-format lyric packet for this setlist
     * @request GET:/setlists/{setlist_id}/packet/lyrics
     * @secure
     */
    getSetlistPacketLyrics: (setlistId: string, params: RequestParams = {}) =>
      this.request<File, ServerError>({
        path: `/setlists/${setlistId}/packet/lyrics`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistPacketPdf
     * @summary Retrieve the PDF-format packet for this setlist
     * @request GET:/setlists/{setlist_id}/packet/pdf
     * @secure
     */
    getSetlistPacketPdf: (
      setlistId: string,
      query?: {
        /**
         * Two Page Align
         * @default false
         */
        two_page_align?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<File, ServerError>({
        path: `/setlists/${setlistId}/packet/pdf`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name ListSetlistPositions
     * @request GET:/setlists/{setlist_id}/pos
     * @secure
     */
    listSetlistPositions: (setlistId: string, params: RequestParams = {}) =>
      this.request<SetlistPositionList, ServerError>({
        path: `/setlists/${setlistId}/pos`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name NewSetlistPosition
     * @request POST:/setlists/{setlist_id}/pos
     * @secure
     */
    newSetlistPosition: (
      setlistId: string,
      data: NewSetlistPosition,
      params: RequestParams = {},
    ) =>
      this.request<SetlistPosition, ServerError>({
        path: `/setlists/${setlistId}/pos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlistPositions
     * @request PUT:/setlists/{setlist_id}/pos
     * @secure
     */
    updateSetlistPositions: (
      setlistId: string,
      data: UpdateSetlistPositions,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/pos`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistPosition
     * @request GET:/setlists/{setlist_id}/pos/{position_id}
     * @secure
     */
    getSetlistPosition: (
      setlistId: string,
      positionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistPosition, ServerError>({
        path: `/setlists/${setlistId}/pos/${positionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlistPosition
     * @request PUT:/setlists/{setlist_id}/pos/{position_id}
     * @secure
     */
    updateSetlistPosition: (
      setlistId: string,
      positionId: string,
      data: UpdateSetlistPosition,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/pos/${positionId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name DeleteSetlistPosition
     * @request DELETE:/setlists/{setlist_id}/pos/{position_id}
     * @secure
     */
    deleteSetlistPosition: (
      setlistId: string,
      positionId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/pos/${positionId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name ListSetlistRecordings
     * @request GET:/setlists/{setlist_id}/recordings
     * @secure
     */
    listSetlistRecordings: (setlistId: string, params: RequestParams = {}) =>
      this.request<SetlistRecordingList, ServerError>({
        path: `/setlists/${setlistId}/recordings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name NewSetlistRecording
     * @request POST:/setlists/{setlist_id}/recordings
     * @secure
     */
    newSetlistRecording: (
      setlistId: string,
      data: NewSetlistRecording,
      params: RequestParams = {},
    ) =>
      this.request<SetlistRecording, ServerError>({
        path: `/setlists/${setlistId}/recordings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistRecording
     * @request GET:/setlists/{setlist_id}/recordings/{recording_id}
     * @secure
     */
    getSetlistRecording: (
      setlistId: string,
      recordingId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistRecording, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlistRecording
     * @request PUT:/setlists/{setlist_id}/recordings/{recording_id}
     * @secure
     */
    updateSetlistRecording: (
      setlistId: string,
      recordingId: string,
      data: UpdateSetlistRecording,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name DeleteSetlistRecording
     * @request DELETE:/setlists/{setlist_id}/recordings/{recording_id}
     * @secure
     */
    deleteSetlistRecording: (
      setlistId: string,
      recordingId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method supports range requests. For large responses, this method returns a 302 Found temporary redirect.
     *
     * @tags Setlists
     * @name GetSetlistRecordingAudio
     * @summary Retrieve the audio attached to the setlist recording
     * @request GET:/setlists/{setlist_id}/recordings/{recording_id}/audio
     * @secure
     */
    getSetlistRecordingAudio: (
      setlistId: string,
      recordingId: string,
      params: RequestParams = {},
    ) =>
      this.request<File, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}/audio`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name ListSetlistRecordingMarks
     * @request GET:/setlists/{setlist_id}/recordings/{recording_id}/marks
     * @secure
     */
    listSetlistRecordingMarks: (
      setlistId: string,
      recordingId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistRecordingMarkList, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}/marks`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name NewSetlistRecordingMark
     * @request POST:/setlists/{setlist_id}/recordings/{recording_id}/marks
     * @secure
     */
    newSetlistRecordingMark: (
      setlistId: string,
      recordingId: string,
      data: NewSetlistRecordingMark,
      params: RequestParams = {},
    ) =>
      this.request<SetlistRecordingMark, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}/marks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistRecordingMark
     * @request GET:/setlists/{setlist_id}/recordings/{recording_id}/marks/{mark_id}
     * @secure
     */
    getSetlistRecordingMark: (
      setlistId: string,
      recordingId: string,
      markId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistRecordingMark, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}/marks/${markId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlistRecordingMark
     * @request PUT:/setlists/{setlist_id}/recordings/{recording_id}/marks/{mark_id}
     * @secure
     */
    updateSetlistRecordingMark: (
      setlistId: string,
      recordingId: string,
      markId: string,
      data: UpdateSetlistRecordingMark,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}/marks/${markId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name DeleteSetlistRecordingMark
     * @request DELETE:/setlists/{setlist_id}/recordings/{recording_id}/marks/{mark_id}
     * @secure
     */
    deleteSetlistRecordingMark: (
      setlistId: string,
      recordingId: string,
      markId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/recordings/${recordingId}/marks/${markId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name ListSetlistSheets
     * @request GET:/setlists/{setlist_id}/sheets
     * @secure
     */
    listSetlistSheets: (setlistId: string, params: RequestParams = {}) =>
      this.request<SetlistSheetList, ServerError>({
        path: `/setlists/${setlistId}/sheets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name NewSetlistSheet
     * @request POST:/setlists/{setlist_id}/sheets
     * @secure
     */
    newSetlistSheet: (
      setlistId: string,
      data: NewSetlistSheet,
      params: RequestParams = {},
    ) =>
      this.request<SetlistSheet, ServerError>({
        path: `/setlists/${setlistId}/sheets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name GetSetlistSheet
     * @request GET:/setlists/{setlist_id}/sheets/{sheet_id}
     * @secure
     */
    getSetlistSheet: (
      setlistId: string,
      sheetId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistSheet, ServerError>({
        path: `/setlists/${setlistId}/sheets/${sheetId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name UpdateSetlistSheet
     * @request PUT:/setlists/{setlist_id}/sheets/{sheet_id}
     * @secure
     */
    updateSetlistSheet: (
      setlistId: string,
      sheetId: string,
      data: UpdateSetlistSheet,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/sheets/${sheetId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Setlists
     * @name DeleteSetlistSheet
     * @request DELETE:/setlists/{setlist_id}/sheets/{sheet_id}
     * @secure
     */
    deleteSetlistSheet: (
      setlistId: string,
      sheetId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/setlists/${setlistId}/sheets/${sheetId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  songs = {
    /**
     * @description All filter parameters are optional. When no filters are provided, all songs on the site will be returned.
     *
     * @tags Songs
     * @name ListSongs
     * @summary List songs
     * @request GET:/songs
     * @secure
     */
    listSongs: (
      query?: {
        /**
         * Ccli Num
         * @default null
         */
        ccli_num?: number | null;
        /**
         * Title
         * @default null
         */
        title?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<SongList, ServerError>({
        path: `/songs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description NOTE: To attach a sheet to a song, you will need to create a song version, then upload the sheet as an object, then create a song sheet that references that object.
     *
     * @tags Songs
     * @name NewSong
     * @summary Create a new song
     * @request POST:/songs
     * @secure
     */
    newSong: (data: NewSong, params: RequestParams = {}) =>
      this.request<Song, ServerError>({
        path: `/songs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name SearchSongs
     * @summary Search for songs
     * @request GET:/songs/search
     * @secure
     */
    searchSongs: (
      query: {
        /** Search query */
        q: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchSongList, ServerError>({
        path: `/songs/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name GetSong
     * @summary Retrieve a single song by ID
     * @request GET:/songs/{song_id}
     * @secure
     */
    getSong: (songId: string, params: RequestParams = {}) =>
      this.request<Song, ServerError>({
        path: `/songs/${songId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name UpdateSong
     * @summary Update a song's fields
     * @request PUT:/songs/{song_id}
     * @secure
     */
    updateSong: (
      songId: string,
      data: UpdateSong,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description NOTE: A song cannot be deleted if it is referenced in a setlist.
     *
     * @tags Songs
     * @name DeleteSong
     * @summary Delete a song
     * @request DELETE:/songs/{song_id}
     * @secure
     */
    deleteSong: (songId: string, params: RequestParams = {}) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name ListSongRevisions
     * @summary List song revisions for a given song ID
     * @request GET:/songs/{song_id}/revisions
     * @secure
     */
    listSongRevisions: (songId: string, params: RequestParams = {}) =>
      this.request<SongRevisionList, ServerError>({
        path: `/songs/${songId}/revisions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name ListSongVersions
     * @summary List song versions for a given song ID
     * @request GET:/songs/{song_id}/versions
     * @secure
     */
    listSongVersions: (songId: string, params: RequestParams = {}) =>
      this.request<SongVersionList, ServerError>({
        path: `/songs/${songId}/versions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name NewSongVersion
     * @summary Create a new song version
     * @request POST:/songs/{song_id}/versions
     * @secure
     */
    newSongVersion: (
      songId: string,
      data: NewSongVersion,
      params: RequestParams = {},
    ) =>
      this.request<SongVersion, ServerError>({
        path: `/songs/${songId}/versions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name GetSongVersion
     * @summary Retrieve a single song version by ID
     * @request GET:/songs/{song_id}/versions/{version_id}
     * @secure
     */
    getSongVersion: (
      songId: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SongVersion, ServerError>({
        path: `/songs/${songId}/versions/${versionId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name UpdateSongVersion
     * @summary Update the fields of a song version
     * @request PUT:/songs/{song_id}/versions/{version_id}
     * @secure
     */
    updateSongVersion: (
      songId: string,
      versionId: string,
      data: UpdateSongVersion,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}/versions/${versionId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description NOTE: A song version cannot be deleted if it is included in a setlist.
     *
     * @tags Songs
     * @name DeleteSongVersion
     * @summary Delete a song version
     * @request DELETE:/songs/{song_id}/versions/{version_id}
     * @secure
     */
    deleteSongVersion: (
      songId: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}/versions/${versionId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name ListSongMedia
     * @summary List media for a given song and version ID
     * @request GET:/songs/{song_id}/versions/{version_id}/media
     * @secure
     */
    listSongMedia: (
      songId: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SongMediaList, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/media`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description To attach an object to a media entry, first use the `/objects` method to upload your object, then provide the resulting ID as the `object_id` field.
     *
     * @tags Songs
     * @name NewSongMedia
     * @summary Create a new media entry for a song version
     * @request POST:/songs/{song_id}/versions/{version_id}/media
     * @secure
     */
    newSongMedia: (
      songId: string,
      versionId: string,
      data: NewSongMedia,
      params: RequestParams = {},
    ) =>
      this.request<SongMedia, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/media`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name GetSongMedia
     * @summary Retrieve a single song media by ID
     * @request GET:/songs/{song_id}/versions/{version_id}/media/{media_id}
     * @secure
     */
    getSongMedia: (
      songId: string,
      versionId: string,
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<SongMedia, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/media/${mediaId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name UpdateSongMedia
     * @summary Update the fields of a media entry
     * @request PUT:/songs/{song_id}/versions/{version_id}/media/{media_id}
     * @secure
     */
    updateSongMedia: (
      songId: string,
      versionId: string,
      mediaId: string,
      data: UpdateSongMedia,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/media/${mediaId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name DeleteSongMedia
     * @summary Delete a media entry for a song version
     * @request DELETE:/songs/{song_id}/versions/{version_id}/media/{media_id}
     * @secure
     */
    deleteSongMedia: (
      songId: string,
      versionId: string,
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/media/${mediaId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method supports range requests. For large responses, this method returns a 302 Found temporary redirect.
     *
     * @tags Songs
     * @name GetSongMediaAttachment
     * @summary Retrieve the attachment associated with a song media
     * @request GET:/songs/{song_id}/versions/{version_id}/media/{media_id}/obj
     * @secure
     */
    getSongMediaAttachment: (
      songId: string,
      versionId: string,
      mediaId: string,
      params: RequestParams = {},
    ) =>
      this.request<File, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/media/${mediaId}/obj`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name ListSongRecordings
     * @summary List recordings of this song
     * @request GET:/songs/{song_id}/versions/{version_id}/recordings
     * @secure
     */
    listSongRecordings: (
      songId: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SetlistRecordingMarkList, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/recordings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name ListSongSheets
     * @summary List song sheets for a given song and version ID
     * @request GET:/songs/{song_id}/versions/{version_id}/sheets
     * @secure
     */
    listSongSheets: (
      songId: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SongSheetList, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/sheets`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description To attach an object to a song sheet, first use the `/objects` method to upload your object, then provide the resulting ID as the `object_id` field.
     *
     * @tags Songs
     * @name NewSongSheet
     * @summary Create a new song sheet for a song version
     * @request POST:/songs/{song_id}/versions/{version_id}/sheets
     * @secure
     */
    newSongSheet: (
      songId: string,
      versionId: string,
      data: NewSongSheet,
      params: RequestParams = {},
    ) =>
      this.request<SongSheet, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/sheets`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name GetSongSheet
     * @summary Retrieve a single song sheet by ID
     * @request GET:/songs/{song_id}/versions/{version_id}/sheets/{sheet_id}
     * @secure
     */
    getSongSheet: (
      songId: string,
      versionId: string,
      sheetId: string,
      params: RequestParams = {},
    ) =>
      this.request<SongSheet, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/sheets/${sheetId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name UpdateSongSheet
     * @summary Update the fields of a song sheet
     * @request PUT:/songs/{song_id}/versions/{version_id}/sheets/{sheet_id}
     * @secure
     */
    updateSongSheet: (
      songId: string,
      versionId: string,
      sheetId: string,
      data: UpdateSongSheet,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/sheets/${sheetId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description NOTE: a song sheet cannot be deleted if it is included in a setlist.
     *
     * @tags Songs
     * @name DeleteSongSheet
     * @summary Delete a song sheet
     * @request DELETE:/songs/{song_id}/versions/{version_id}/sheets/{sheet_id}
     * @secure
     */
    deleteSongSheet: (
      songId: string,
      versionId: string,
      sheetId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/sheets/${sheetId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This method supports range requests. For large responses, this method returns a 302 Found temporary redirect.
     *
     * @tags Songs
     * @name GetSongSheetDoc
     * @summary Retrieve the document associated with a song sheet
     * @request GET:/songs/{song_id}/versions/{version_id}/sheets/{sheet_id}/doc
     * @secure
     */
    getSongSheetDoc: (
      songId: string,
      versionId: string,
      sheetId: string,
      params: RequestParams = {},
    ) =>
      this.request<File, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/sheets/${sheetId}/doc`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Songs
     * @name ListSongVersionsSimilar
     * @summary List song versions similar to the given version
     * @request GET:/songs/{song_id}/versions/{version_id}/similar
     * @secure
     */
    listSongVersionsSimilar: (
      songId: string,
      versionId: string,
      params: RequestParams = {},
    ) =>
      this.request<SongVersionList, ServerError>({
        path: `/songs/${songId}/versions/${versionId}/similar`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name ListUsers
     * @request GET:/users
     * @secure
     */
    listUsers: (params: RequestParams = {}) =>
      this.request<UserList, ServerError>({
        path: `/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUser
     * @request GET:/users/{user_id}
     * @secure
     */
    getUser: (userId: string, params: RequestParams = {}) =>
      this.request<User, ServerError>({
        path: `/users/${userId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UpdateUser
     * @request PUT:/users/{user_id}
     * @secure
     */
    updateUser: (
      userId: string,
      data: UpdateUser,
      params: RequestParams = {},
    ) =>
      this.request<any, ServerError>({
        path: `/users/${userId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name CreateUserApikey
     * @request POST:/users/{user_id}/apikey
     * @secure
     */
    createUserApikey: (userId: string, params: RequestParams = {}) =>
      this.request<UserApikey, ServerError>({
        path: `/users/${userId}/apikey`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
